export default "__VITE_ASSET__9cc152fb__"